var SEARCH_PROVIDER = context => {
  var locale = context.locale || context.state.i18n.currentLocale;
  var openMarkets = {
    'fr-FR': true,
    'es-ES': true,
    'nl-BE': true,
    'fr-BE': true,
    'de-DE': true,
    'it-IT': true,
    'fr-LU': true,
    'nl-NL': true,
    'de-AT': true,
    'pt-PT': true,
    'de-CH': true,
    'it-CH': true,
    'fr-CH': true,
    'en-GB': true
  };
  return openMarkets[locale.iso] ? 'algolia' : 'elastic';
};
export default SEARCH_PROVIDER;